import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './shared/components/Layout';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import DesignEngineeringPage from './components/DesignEngineeringPage';
import FabricationErectionPage from './components/FabricationErectionPage';
import MachiningPage from './components/MachiningPage';
import PlantMaintenancePage from './components/PlantMaintenancePage';
import ServicesPage from './components/ServicesPage';
import ContactPage from './components/ContactPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route
            path="/services/design-engineering"
            element={<DesignEngineeringPage />}
          />
          <Route
            path="/services/fabrication-erection"
            element={<FabricationErectionPage />}
          />
          <Route path="/services/machining" element={<MachiningPage />} />
          <Route
            path="/services/plant-maintenance"
            element={<PlantMaintenancePage />}
          />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
